import Schema from 'AppReact/schema';

export default {
  selectedDueDateIds: Schema('integer', 'array', { defaultValue: [] }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  dueDates: Schema('string', 'array', { defaultValue: [] }),
  hasExportError: Schema('boolean', 'primitive', { defaultValue: false }),
};
